import { useQuery } from "@tanstack/react-query";
import { getAdmin } from "app/api/admin_api";
export const useGetAdmin = ({ keys = [], id }) => {
  return useQuery({ queryKey: ["admin", ...keys], queryFn: () => getAdmin(id), enabled: !!id });
};
